window.WordCloudStyle = {};

window.WordCloudStyle.getTemplates = function(){
	var themeArray = [];
	themeArray.push({theme:{
			img:'images/wordcloud_templates/0.png', id: 0, name: "Happy", styles:[
				"text_font|tahoma", "bgcolor|transparent", "usecustompalette|True", "customcolorsnumber|5", "minwordsize|10px", "maxwordsize|48px",
				"customcolor1|#0081c7","customcolor2|#003952","customcolor3|#e2001a","customcolor4|#fabb00","customcolor5|#97bf0d"
			]
		}});
	themeArray.push({theme:{
			img:'images/table_templates/1.png', id: 1, name: "Solid", styles:[
				"text_font|tahoma", "bgcolor|transparent", "usecustompalette|True", "customcolorsnumber|5", "minwordsize|10px", "maxwordsize|48px",
				"customcolor1|#4aacc5","customcolor2|#c0504e","customcolor3|#9bbb58","customcolor4|#8064a1","customcolor5|#f79647"
			]
		}});
	themeArray.push({theme:{
			img:'images/table_templates/2.png', id: 2, name: "Solid Dark", styles:[
				"text_font|tahoma", "bgcolor|transparent", "usecustompalette|True", "customcolorsnumber|5", "minwordsize|10px", "maxwordsize|48px",
				"customcolor1|#30859a","customcolor2|#953735","customcolor3|#78913d","customcolor4|#5f497a","customcolor5|#e36c08"
			]
	}});
	themeArray.push({theme:{
			img:'images/table_templates/3.png', id: 3, name: "Greyscale", styles:[
				"text_font|tahoma", "bgcolor|transparent", "usecustompalette|True", "customcolorsnumber|5", "minwordsize|10px", "maxwordsize|48px",
				"customcolor1|#000000","customcolor2|#3f3f3f","customcolor3|#7f7f7f","customcolor4|#a5a5a5","customcolor5|#bfbfbf"
			]
	}});
	return themeArray;
}